// extracted by mini-css-extract-plugin
export default {"wrapper":"DXHVJne","content":"_3yXvDK","title":"DgbsHjH","subtitle":"DWk2fzt","pagebar":"_KCleDl","pagebarTitle":"yTymBZc","pagebarSubtitle":"DXR4PZ5","actions":"hprlPUS"};